import { config } from '../config';
import { tokenManager } from '../auth/tokenManager';

export interface UserPoints {
  id: number;
  user_id: number;
  total_points: number;
  lifetime_points: number;
  created_at: string;
  updated_at: string;
}

export interface PointsTransaction {
  id: number;
  user_id: number;
  points: number;
  transaction_type: string;
  description: string | null;
  referral_id: number | null;
  created_at: string;
}

export const pointsApi = {
  getUserPoints: async (userId: number): Promise<UserPoints> => {
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/${userId}/points`);

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.detail || data.message || response.statusText);
    }

    return response.json();
  },

  getPointsHistory: async (userId: number): Promise<PointsTransaction[]> => {
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/${userId}/points/history`);

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.detail || data.message || response.statusText);
    }

    return response.json();
  },
};
